import { create } from "zustand";
import { loadGIFSound, setGIFSound } from "@/common/utils/storage";

interface IAppState {
  // initial state
  isBurgerMenuOpen: boolean;
  isProfileMenuOpen: boolean;
  isSearchBarOpen: boolean;
  gifSound: boolean;
  isFullScreen: boolean;
  isMobileFullscreen: boolean;

  // actions
  toggleBurgerMenu: () => void;
  toggleProfileMenu: () => void;
  toggleGifSound: (gifSound: boolean) => void;
  toggleFullScreen: (isFullScreen: boolean) => void;
  toggleMobileFullscreen: (isMobileFullscreen: boolean) => void;
  hideAllMenus: () => void;
  openSearch: () => void;
  closeSearch: () => void;
}

export const useAppStore = create<IAppState>(
  (set) => ({
    // initial state
    isBurgerMenuOpen: false,
    isProfileMenuOpen: false,
    isSearchBarOpen: false,
    gifSound: loadGIFSound(),
    isFullScreen: false,
    isMobileFullscreen: false,

    // actions
    toggleBurgerMenu: () => set((state) => ({ isBurgerMenuOpen: !state.isBurgerMenuOpen })),
    toggleProfileMenu: () => set((state) => ({ isProfileMenuOpen: !state.isProfileMenuOpen })),
    openSearch: () => set({ isSearchBarOpen: true }),
    closeSearch: () => set({ isSearchBarOpen: false }),
    toggleGifSound: (gifSound: boolean) => set(() => {
      setGIFSound(JSON.stringify(gifSound));
      return { gifSound };
    }),
    toggleFullScreen: (isFullScreen: boolean) => set(() => ({ isFullScreen })),
    toggleMobileFullscreen: (isMobileFullscreen: boolean) => set(() => ({ isMobileFullscreen })),
    hideAllMenus: () => set(() => ({
      isSearchBarOpen: false,
      isBurgerMenuOpen: false,
      isProfileMenuOpen: false,
    })),
  }),
);
